import { LBtn } from "../../../../../../../common/components/LBtn";
import { useModal } from "../../../../../../../services/ModalContext";

export const StaffModalButtons = ({ ...props }: StaffModalButtonProps): JSX.Element => {
    const { closeModal } = useModal();

    return (
        <div className="pt-2 is-clearfix">
            {props.error && <p className="help is-danger">{"One user entered is invalid."}</p>}
            <div className="divider" />
            <div className="columns">
                <div className="column" />
                <div className="column is-4">
                    <LBtn variation="outline" fullWidth onClick={closeModal}>
                        Cancel
                    </LBtn>
                </div>
                <div className="column is-1" />
                <div className="column is-4">
                    <LBtn
                        fullWidth
                        type="submit"
                        disabled={props.disabled}
                        onClick={props.onConfirm}
                        loading={props.loading}
                    >
                        {props.confirmText}
                    </LBtn>
                </div>
                <div className="column" />
            </div>
        </div>
    );
};

interface StaffModalButtonProps {
    confirmText: string;
    disabled?: boolean;
    loading?: boolean;
    error?: boolean;
    onConfirm?: () => void;
}
